import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as sendmailActions from 'external/reduxBits/sendmail/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { adData, motorAdData, globalData } from 'tracking/dataCollectors'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view',
      eventType: 'View',
      objectId: _.get(state, 'classified.requestedAd.ad.listId', undefined),
      domain: 'adout',
      subDomain: 'adreply',
      ...adData(_.get(state, 'classified.requestedAd.ad', {})),
      objectCustom: {
        motorCarTradeInChecked: _.get(state.motor, 'adReplyOptions.tradeIn.checked') ? true : false, // eslint-disable-line no-unneeded-ternary
        motorFinanceAdreplyCheckboxInterestedChecked: _.get(state.motor, 'adReplyOptions.finance')
          ? true // eslint-disable-line no-unneeded-ternary
          : false,
        ...motorAdData(_.get(state, 'classified.requestedAd.ad', {})),
      },
      origin: {
        id: `${_.get(state, 'classified.requestedAd.ad.listId', undefined)}`,
        type: 'ClassifiedAd',
        name: `${_.get(state, 'classified.requestedAd.ad.subject', undefined)}`,
        category: ' ',
      },
    },
    ...localData,
  })

export const formConfirmation = {
  validators: [validators.redux(sendmailActions.RECEIVE_SENDMAIL, ({ error }) => !error)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectName: 'Ad reply form sent',
        objectType: 'Confirmation',
      }),
    ),
  ],
}

export const formError = {
  validators: [validators.redux(sendmailActions.RECEIVE_SENDMAIL, ({ error }) => error)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectName: 'Ad reply form error',
        objectType: 'Error',
        eventCategory: 'error',
        eventAction: 'error sending message',
      }),
    ),
  ],
}

export const viewAdreply = {
  validators: [
    validators.redux('@@router/LOCATION_CHANGE', (action) => {
      return _.get(action, 'payload.location.pathname', '').includes('svara-annons')
    }),
  ],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectName: 'Ad reply form view',
        objectType: 'Form',
        objectItemId: _.get(state, 'classified.requestedAd.ad.adId', undefined),
      }),
    ),
  ],
}
